export const getLayoutClassName = (layout, componentClass) => {
  let className = "";

  switch (layout) {
    case "grid":
      className = `${componentClass} ${componentClass}-grid`;
      break;

    default:
      className = `${componentClass}`;
      break;
  }

  return className;
};

export const getContainerClassName = (layout, componentClass, blockName) => {
  let className = "";

  const shouldHaveContainer = !blockName?.includes("product-info");

  switch (layout) {
    case "grid":
      className = `container ${componentClass} ${componentClass}--grid`;
      break;

    default:
      className = `${shouldHaveContainer ? "container " : ""}${componentClass}`;
      break;
  }

  return className;
};
